// extracted by mini-css-extract-plugin
module.exports = {"modal":"ShareShoppingCart_modal__Tb_sR","copyLink":"ShareShoppingCart_copyLink__wkzd2"};